import React, {useReducer, useEffect, useState} from 'react';

import ModalContentWrapper from '../ModalContentWrapper';
import useAutoForm from "../../Forms/useAutoForm";
import {saveNewPassword} from "../../DataFunctions/UserDataFns";

const ModalChangePassword = (props) =>
{
    const [ ,forceRender] = useReducer((s) => s+1, 0)
    const [ initialiseForm, renderForm, isFormValid, getFormData, setDisplayErrors, isInitialised] = useAutoForm( forceRender ) ;
    const [ buttonState, setButtonState ] = useState ('') ;

    useEffect(() => {
        initForm();
    }, [props.user_id]);

    const initForm = () =>
    {
        const items = [
            {
                ref: 'InputPassword',
                tabIndex: 1,
                item_name: 'newPassword',
                default: "",
                label: 'New Password',
                errorText: 'You must complete this section',
                field_type: 'input',
                data_type: 'string',
                controlled: true,
                validation: {},
                colSpan: 6,
                lineBreak: false,
                value: null,
            },
            {
                ref: 'InputPasswordConfirm',
                tabIndex: 2,
                item_name: 'confirmedPassword',
                default: null,
                label: 'Confirm Password ',
                errorText: 'You must confirm your password',
                field_type: 'input',
                data_type: 'string',
                controlled: true,
                validation: {},
                colSpan: 6,
                lineBreak: false,
                value: null
            },
        ];

        initialiseForm( items, props.mode );
    }

    const onSaveComplete = () =>
    {
        props.onSaveCompleted ('saved');
        props.onClose() ;
    }

    const onClickCancel = () =>
    {
        props.onClose() ;
    }

    const doSaveNew = ( callback ) =>
    {
        if ( !isFormValid())
        {
            setDisplayErrors( true ) ;
            setButtonState ( '' ) ;
        }
        else
        {
            const data = getFormData() ;
            saveNewPassword(props.user_id, data, onSaveComplete ) ;
        }
    }

    const onClickSave = () =>
    {
        doSaveNew(onSaveComplete) ;
    }

    const disableButtons = () =>
    {
        setButtonState ('disabled');
    }

    const saveButton = () =>
    {
        let clickHandler = null ;

        if ( buttonState == '')
        {
            clickHandler = onClickSave ;
        }

        return (
            <button disabled={buttonState} onClick={clickHandler} className="btn btn-primary nutritroops-btn-primary">Save<i className="et-save"></i></button>
        )
    }

    return (

        <ModalContentWrapper className="modal-wrapper">
            <h3>Change Password</h3>

            <div className="post" style={{width: '600px'}}>
                { /* This renders the user input part of the form */ }
                {isInitialised && renderForm( { readonly: false })}
            </div>

            <div className="d-flex flex-row justify-content-end">
                <div className="p-2">{saveButton()}</div>
                <div className="p-2"><button onClick={onClickCancel} className="btn btn-secondary nutritroops-btn-secondary">Cancel<i className="et-arrow-bold-left"></i></button></div>
            </div>
        </ModalContentWrapper>
    )
}

export default ModalChangePassword;
